import React, { useState, useEffect } from 'react';
import AuthService from '../services/AuthService';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../components/Loader';
import logo from '../assets/images/logo.png';
import './Login.css';

const slides = [
  {
    title: 'System Command Hub',
    description: 'Monitor all businesses, enforce compliance, and ensure seamless operations—from one centralized dashboard.'
  },
  {
    title: 'Comprehensive Analytics',
    description: 'Get real-time insights into your business metrics, user engagement, and performance indicators at a glance.'
  },
  {
    title: 'Advanced Management',
    description: 'Streamline operations with powerful tools for user management, booking oversight, and content moderation.'
  }
];

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [isLoader, setIsLoader] = useState(false);
  const [requiresOTP, setRequiresOTP] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (AuthService.getCurrentUser()) {
      navigate('/admin/dashboard');
    }
  }, [navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const data = await AuthService.login(email, password, otp);
      if (data.status) {
        toast.success(data.message);
        let user = data.data.admin;
        user.auth_token = data.data.auth_token;
        localStorage.setItem('admin', JSON.stringify(user));
        localStorage.setItem('permissions', JSON.stringify(data.data.permissions));
        window.location.href = process.env.REACT_APP_BASE_PATH + '/admin/dashboard';
      } else {
        if (data.requires_otp) {
          setRequiresOTP(true);
          toast.info(data.message || 'OTP sent to your email');
        } else {
          toast.error(data.message);
        }
      }
    } catch (error) {
      console.error('Login failed:', error);
      toast.error('Login failed. Please try again.');
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left-panel">
        <div className="left-panel-content">
          <div className="slider-container">
            <div
              className="slider-wrapper"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {slides.map((slide, index) => (
                <div key={index} className="slide">
                  <h1 className="left-panel-title">{slide.title}</h1>
                  <p className="left-panel-description">{slide.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="navigation-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="login-right-panel">
        <div className="login-form-container">
          <div className="login-form-content">
            <div className="logo-section">
              <img src={logo} alt="Logo" className="logo-image w-100px" />
            </div>

            <h2 className="login-title">Admin Portal</h2>

            <form onSubmit={handleLogin} className="login-form">
              <div className="form-group">
                <input
                  type="email"
                  required
                  autoComplete="off"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-input"
                  placeholder="Enter email"
                />
              </div>

              <div className="form-group">
                <input
                  type="password"
                  className="form-input"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  autoComplete="off"
                />
              </div>

              {requiresOTP && (
                <div className="form-group">
                  <input
                    type="text"
                    className="form-input"
                    required
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    placeholder="Enter 6-digit OTP"
                    autoComplete="off"
                    maxLength="6"
                  />
                  <p className="text-muted small mt-2 mb-0">
                    A verification code has been sent to your email. Please enter it above.
                  </p>
                </div>
              )}

              <div className="form-options">
                <label className="checkbox-container">
                  <input type="checkbox" className="checkbox-input" />
                  <span className="checkmark"></span>
                  Remember me
                </label>
              </div>

              <button type="submit" disabled={isLoader} className="login-button">
                {isLoader ? <Loader size="20" text="Signing" color="white" /> : 'Login'}
              </button>
            </form>
          </div>

          <p className="terms-text">
            By logging in you agree to our{' '}
            <a href="#" className="terms-link">Terms of Service</a> and{' '}
            <a href="#" className="terms-link">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
